(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid-variants"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function hydrateVariantTiles() {
    const items = document.querySelectorAll('.product-grid__item[data-variant-id]');
    items.forEach((item) => {
      const url = item.dataset.variantUrl;
      const title = item.dataset.variantTitle;
      const price = item.dataset.variantPrice;
      const compare = item.dataset.variantCompare;
      const image = item.dataset.variantImage;
      if (!url) return;

      item.querySelectorAll('a[href]').forEach((a) => {
        if (a.classList.contains('swatch') || a.closest('product-swatches')) return;
        a.setAttribute('href', url);
      });

      const hidden = item.querySelector('.product-card__link .visually-hidden');
      if (hidden && title) hidden.textContent = title;

      const titleContainer = item.querySelector('[ref=\"productTitleLink\"], product-title a, .product-grid-view-zoom-out--details h3');
      if (titleContainer && title) {
        const p = titleContainer.querySelector('p');
        if (p) p.textContent = title;
        else titleContainer.textContent = title;
      }
      const zoomTitle = item.querySelector('.product-grid-view-zoom-out--details h3');
      if (zoomTitle && title) zoomTitle.textContent = title;

      if (price) {
        const priceEl = item.querySelector('product-price .price');
        if (priceEl) priceEl.textContent = price;
      }
      const compareEl = item.querySelector('product-price .compare-at-price');
      if (compareEl) {
        if (compare) compareEl.textContent = compare;
        else compareEl.textContent = '';
      }

      if (image) {
        const img = item.querySelector('.card-gallery img');
        if (img) {
          img.setAttribute('src', image);
          img.setAttribute('srcset', image);
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', hydrateVariantTiles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
